export default __webpack_public_path__ + "static/snazni169-4a13431c841ea3e40143a9209f685c0b.png";